var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-container" }, [
    _c("div", { staticClass: "page-header-container" }, [
      _c(
        "div",
        { staticClass: "page-header" },
        [
          _c("span", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.$t("user.profile.title"))),
          ]),
          _vm._v(" "),
          _c("FormActionBtns", {
            staticClass: "action-btns",
            attrs: {
              hiddenAdd: true,
              onCancel: _vm.cancel,
              onSave: _vm.saveProfile,
            },
            model: {
              value: _vm.status,
              callback: function ($$v) {
                _vm.status = $$v
              },
              expression: "status",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "profile-main" }, [
      _c("div", { staticClass: "profile-basic" }, [
        _c("div", { staticClass: "profile-section-title" }, [
          _vm._v(_vm._s(_vm.$t("user.profile.basicInformation"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile-item" }, [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("username"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "label-content" }, [
            _vm._v(_vm._s(_vm.pendingUpdateUser.username)),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "profile-item" },
          [
            _c("label", { staticClass: "emphasis" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("user.email")) + "\n          "
              ),
              _c("span", { staticClass: "label-tip" }, [
                _vm._v(_vm._s(_vm.$t("user.profile.2faOnly"))),
              ]),
            ]),
            _vm._v(" "),
            _c("InputField", {
              attrs: {
                extendClass: _vm.isValidEmail ? "" : "error-highlight",
                readonly: !_vm.isEdit,
                showFlag: false,
                showColon: false,
                value: _vm.primaryContactEmail,
              },
              on: { updateValue: _vm.updateContactEmail },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "profile-item" }, [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(
              "\n          " + _vm._s(_vm.$t("user.phone")) + "\n          "
            ),
            _c("span", { staticClass: "label-tip" }, [
              _vm._v(_vm._s(_vm.$t("user.profile.2faOnly"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "phone-field" }, [
            !_vm.isEdit
              ? _c("span", { staticClass: "label-content" }, [
                  _vm._v(
                    _vm._s(
                      _vm.currentNationalCode &&
                        _vm.currentNationalCode.dial_code
                    )
                  ),
                ])
              : _c(
                  "div",
                  { staticClass: "national-code__selector" },
                  [
                    _c("HKLSelect", {
                      attrs: {
                        value: _vm.selectedNationalCodeValue,
                        options: _vm.nationalCodeHklOptions,
                        showSearch: true,
                        placeholder: _vm.$t("user.countryCode"),
                      },
                      on: { change: _vm.onNationalCodeChange },
                    }),
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "phone-number__input" },
              [
                _c("InputField", {
                  attrs: {
                    extendClass: _vm.isValidPhone ? "" : "error-highlight",
                    readonly: !_vm.isEdit,
                    showFlag: false,
                    showColon: false,
                    value: _vm.currentPhoneNumber,
                  },
                  on: { updateValue: _vm.updatePhoneNumber },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.mainContactsInfo
          ? _c("div", { staticClass: "profile-item" }, [
              _c("label", { staticClass: "emphasis" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("common.remarks")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "label-content" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("user.profile.remarkContent", [_vm.mainContactsInfo])
                  )
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "profile-account-and-dashboard" }, [
        _c(
          "div",
          { staticClass: "profile-account" },
          [
            !_vm.globalOptionsReady
              ? [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("loading")) + "\n        "
                  ),
                ]
              : [
                  _c("div", { staticClass: "profile-section-title" }, [
                    _vm._v(_vm._s(_vm.$t("user.profile.accountInformation"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "profile-item" },
                    [
                      _c("label", { staticClass: "emphasis" }, [
                        _vm._v(_vm._s(_vm.$t("user.profile.defaultLanguage"))),
                      ]),
                      _vm._v(" "),
                      !_vm.isEdit || _vm.languageOptions.length <= 1
                        ? _c("span", { staticClass: "label-content" }, [
                            _vm._v(
                              _vm._s(_vm.customLangLabel(_vm.selectedLanguage))
                            ),
                          ])
                        : _c("HKLSelect", {
                            attrs: {
                              value: _vm.selectedLanguageId,
                              options: _vm.languageHklOptions,
                              showSearch: true,
                              placeholder: "",
                            },
                            on: { change: _vm.onLanguageChange },
                          }),
                    ],
                    1
                  ),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "profile-dashboard" }, [
          _c("div", { staticClass: "profile-section-title" }, [
            _vm._v(_vm._s(_vm.$t("user.profile.passwordInformation"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "profile-section-content" }, [
            _c("div", { staticClass: "profile-item" }, [
              _c("label", { staticClass: "emphasis" }, [
                _vm._v(_vm._s(_vm.$t("user.profile.resetPassword"))),
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "emphasis" }, [
                _vm._v(_vm._s("*".repeat(10))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "profile-item" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue",
                  on: {
                    click: function ($event) {
                      return _vm.resetPassword()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.requestToResetPassword")))]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }